angular
    .module('festzelt-os.components')
    .filter('range', [
        range
    ]);

function range() {
    return function (input, min, max) {
        min = parseInt(min);
        max = parseInt(max);

        for (min; min <= max; min++) {
            input.push(min);
        }
        return input;
    };
}



// WEBPACK FOOTER //
// ./src/app/components/filters/range.js